<!-- GamePlayer.vue -->
<script setup>
import { ref, computed } from 'vue'
import { useAuthStore } from '../stores/auth'
import { usePlayerStore } from '../stores/player/playerStore'
import { useI18n } from 'vue-i18n'
import LanguageSwitcher from './LanguageSwitcher.vue'  // Agregamos esta línea
import PlayerReports from '../components/online/PlayerReports.vue';

// Props correctamente utilizados
const { isMobileView } = defineProps({
  isMobileView: {
    type: Boolean,
    required: true
  }
})
const { t } = useI18n()
const authStore = useAuthStore()
const playerStore = usePlayerStore()
const showReports = ref(false);



//modal para mobile
const showMobileMenu = ref(false)
const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value
}

// Estado y lógica para el modal de balance
const showBalanceInfo = ref(false)
const toggleBalanceInfo = () => {
  showBalanceInfo.value = !showBalanceInfo.value
  if (showBalanceInfo.value) {
    setTimeout(() => {
      showBalanceInfo.value = false
    }, 90000)
  }
}


const currency_prefix = computed(() => playerStore.currencyPrefix)
const formattedBalance = computed(() => {
  return Number(playerStore.balance).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

const isAuthenticated = computed(() => authStore.isAuthenticated);
const openReports = () => {
  showReports.value = true;
};

const closeReports = () => {
  showReports.value = false;
};
</script>

<template>
  <template v-if="isMobileView && isAuthenticated">
    <!-- Menú mobile -->
    <div class="mobile-menu-wrapper">
      
      <button class="balance-button" @click="toggleMobileMenu">
        <span class="balance-amount">
          {{ t('account.credit') }}: <p>{{ currency_prefix }} {{ formattedBalance }}</p>
        </span>
      </button>
      
      <div v-if="showMobileMenu" class="modal-overlay" @click.self="toggleMobileMenu">
        <div class="modal-content">
          <div class="modal-header">
             <LanguageSwitcher />
            <h3>{{ t('account.title') }}</h3>
            <button class="close-button" @click="toggleMobileMenu">
              <font-awesome-icon :icon="['fas', 'times']" />
            </button>
          </div>

          <div class="modal-body">
            <button @click="openReports" class="reports-button">
      <i class="fas fa-chart-bar"></i>{{ t('report.tittle') }}
    </button>
    <!-- Modal de reportes -->
    <div v-if="showReports" class="modal-overlay">
      <PlayerReports @close="closeReports" />
    </div>
            <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'sack-dollar']" /> {{ t('account.credit') }}
              </span>
              <span class="info-value">{{ currency_prefix }} {{ formattedBalance }}</span>
            </div>

            <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'gift']" /> {{ t('account.bonus') }}
              </span>
              <span class="info-value"> {{ currency_prefix }} {{ playerStore.formattedBonusBalance }}</span>
            </div>

            <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'desktop']" /> {{ t('account.terminal') }}
              </span>
              <span class="info-value">{{ authStore.user?.username }}</span>
            </div>

            <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'user']" /> {{ t('account.id') }}
              </span>
              <span class="info-value">{{ authStore.user?.id }}</span>
            </div>

            <button @click="authStore.logout" class="logout-btn">
              <font-awesome-icon :icon="['fas', 'right-from-bracket']" /> {{ t('account.logout') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  

  <!-- Footer para desktop -->
  <template v-if="!isMobileView && isAuthenticated">
    <footer class="games-footer desktop-only">
      <div class="footer-left">
        <!-- Credit button que activa el modal -->
        <div class="balance-container">
          
          <span class="credit" @click="toggleBalanceInfo" style="cursor: pointer;">
            <font-awesome-icon :icon="['fas', 'sack-dollar']" /> 
            {{ t('account.credit') }}: {{ currency_prefix }} {{ formattedBalance }}
          </span>
          
          <!-- Modal de información -->
          <div v-if="showBalanceInfo" class="balance-popup">
            <div class="modal-header">
              <h4>{{ t('account.title') }}</h4>
              <button class="close-button" @click="showBalanceInfo = false">
                <font-awesome-icon :icon="['fas', 'times']" />
              </button>
            </div>

            <div class="modal-body">
              <button @click="openReports" class="reports-button">
      <i class="fas fa-chart-bar"></i>{{ t('report.tittle') }}
    </button>
    <!-- Modal de reportes -->
    <div v-if="showReports" class="modal-overlay">
      <PlayerReports @close="closeReports" />
    </div>
              <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'sack-dollar']" /> {{ t('account.balance') }}
              </span>
              <span class="info-value">{{ currency_prefix }} {{ formattedBalance }}</span>
            </div>

            <div class="info-item">
              <span class="info-label">
                <font-awesome-icon :icon="['fas', 'desktop']" /> {{ t('account.terminal') }}
              </span>
              <span class="info-value">{{ authStore.user?.username }}</span>
            </div>

            <div class="info-item">
                <span class="info-label">
                  <font-awesome-icon :icon="['fas', 'user']" /> {{ t('account.id') }}
                </span>
                <span class="info-value">{{ authStore.user?.id }}</span>
              </div>
            </div>
          </div>
        </div>

        <span class="bonus-credit">
          <font-awesome-icon :icon="['fas', 'gift']" /> 
          {{ t('account.bonus') }}: {{ currency_prefix }} {{ playerStore.formattedBonusBalance }}
        </span>
      </div>
      
      <div class="footer-right">
        <LanguageSwitcher />
        <button @click="authStore.logout" class="logout-button">
          <font-awesome-icon :icon="['fas', 'right-from-bracket']" /> {{ t('account.logout') }}
        </button>
      </div>
    </footer>
  </template>
</template>

<style scoped>
@import '../assets/styles/main.css';
</style>